import React, { useEffect, useState } from 'react';
import { observer } from "mobx-react";
import { Button, Form, Input, notification } from "antd";
import AppealForm from "../../components/appeal/form";
import AuthComp from "../../components/appeal/auth";
import { useStores } from "../../store";
import { Trans, useTranslation } from "react-i18next";
import ClickAwayListener from "react-click-away-listener";
import { useMediaQuery } from "react-responsive";
import MobileNavigation from "../../components/navigation";
import SmileOutlined from "@ant-design/icons/lib/icons/SmileOutlined";
import { useLocation } from "react-router-dom";


 const  AppealPage = () => {
   const location = useLocation()
   const isMobile = useMediaQuery({ query: '(max-width: 1099px)' })
   const [filter, setFilter] = useState(false)
   const isBigScreen = useMediaQuery({ query: '(min-width: 1100px)' })
   const [form] = Form.useForm()
   const {appeals, app, Modals, profile} = useStores()
   const {i18n, t} = useTranslation()

   useEffect(()=>{
     appeals.getPMCategory()
   }, [appeals])
   const onFInish = async e =>{
     const {value} = e.target;
     const error = await appeals.search({q:value});
     if(!error){
       // form.resetFields()
     }
   };

   const showAuth = (key) => {
     Modals.show('auth');
     notification.close(key);
   };
   const getSubcategories = (item) => {
     if(app.access){
       appeals.getForm(item.id, item)
     }else{
       const key = 1;
       const btn = (
         <Button className={'primary'} size="small" onClick={()=>showAuth(key)}>
           <Trans>Авторизоваться</Trans>
         </Button>
       );
       notification.open({
         message: t('Внимание!'),
         description:
           t('Для подачи идеи вам нужно авторизоваться'),
         btn,
         icon: <SmileOutlined style={{ color: '#faad14' }} />,
         key,
       });
     }
   }
   const getPMSubcategories = async (item) => {
     if(item.is_youth_agency){
       return getSubcategories(item)
     }
     await appeals.getPMSubcategories(item.pm_gov_id);
   }
  return (
    <>
      {
        (isMobile && location.pathname.length > 4) && <MobileNavigation title={<Trans>Отправка обращения</Trans>}/>
      }
      <div className={'home appeals-block animate__animated animate__fadeIn'}>
        <div className={'home-section appeals-block'}>
          <div className={'center-content'}>
            <div className={'header-title'}>
              <h1><Trans>Отправка обращении в министерство и ведомства</Trans></h1>
            </div>
            <div className={'appeals-box'}>
              {
                isMobile && <div className={'search-box'}>
                  <Form form={form}>
                    <Form.Item name={'q'}>
                      <Input autoComplete="off"  onChange={onFInish} placeholder={t('Введите текст для поиска')}/>
                    </Form.Item>
                  </Form>
                </div>
              }
              <ClickAwayListener onClickAway={()=>isMobile && setFilter(false)}>
                <div className={'category-list'}>
                  {
                    isMobile && <button className={'filter-btn'} onClick={()=>setFilter(!filter)}>
                      <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M0.5 1C0.5 0.734784 0.605357 0.48043 0.792893 0.292893C0.98043 0.105357 1.23478 0 1.5 0H13.5C13.7652 0 14.0196 0.105357 14.2071 0.292893C14.3946 0.48043 14.5 0.734784 14.5 1V4C14.4999 4.26519 14.3946 4.51951 14.207 4.707L9.5 9.414V13C9.49994 13.2652 9.39455 13.5195 9.207 13.707L7.207 15.707C7.06715 15.8468 6.88898 15.942 6.69503 15.9806C6.50108 16.0192 6.30005 15.9993 6.11735 15.9237C5.93465 15.848 5.77848 15.7199 5.6686 15.5555C5.55871 15.391 5.50004 15.1978 5.5 15V9.414L0.793 4.707C0.605451 4.51951 0.500057 4.26519 0.5 4V1Z" fill="white"/>
                      </svg>
                      <Trans>Фильтр</Trans>
                    </button>
                  }
                  <ul className={filter ? 'show' : null}>
                    {
                      appeals.pm.categories.map((item, index) => {
                        return (item && !(item.id === 11111 || item.id === 11122)) &&
                          item[`title_${i18n.language}`] ? <li key={index}>
                            <button
                              onClick={()=> {getPMSubcategories(item).then(r => setFilter(false)); }}>
                              {
                                item[`title_${i18n.language}`]
                              }
                            </button>
                          </li> : null
                      })
                    }
                  </ul>
                </div>
              </ClickAwayListener>

              <div className={'appeals-content'}>
                {
                  isBigScreen && <div className={'search-box'}>
                    <Form form={form}>
                      <Form.Item name={'q'}>
                        <Input autoComplete="off" onChange={onFInish} placeholder={t('Введите текст для поиска')}/>
                      </Form.Item>
                    </Form>
                  </div>
                }
                <div className={'subcategories'}>
                  {
                    ((appeals.step === 1 || appeals.step === 2)) ?
                      appeals.pm.subcategories.length > 0 ?
                        <ul>
                          {
                            appeals.pm.subcategories.map((item, index) => {
                              return  item[`title_${i18n.language}`] ? <li onClick={()=> getSubcategories(item)} key={index}><button>{item[`title_${i18n.language}`].toLowerCase()}</button></li> : null
                            })
                          }
                        </ul>
                        :
                        <div className={'empty d-flex align-center justify-center'}>
                          <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M53.3909 25.139C52.4578 26.0096 51.887 27.1546 51.7552 28.402C49.772 27.1765 47.1301 27.3485 45.3993 28.9617C44.4662 29.8323 43.8954 30.9772 43.7637 32.2246C41.7804 30.9992 39.1385 31.1711 37.4077 32.7843C36.5186 33.6146 35.9587 34.6901 35.794 35.868L27.2536 27.3302C25.2484 25.3256 21.9625 25.2341 19.9316 27.129C18.8815 28.1057 18.2924 29.4299 18.2667 30.8602C18.2411 32.2904 18.7827 33.6366 19.7963 34.6462L37.3272 52.1717C36.6759 52.1242 36.0136 52.2047 35.3732 52.4058C34.045 52.8302 32.9582 53.7447 32.3179 54.9847C31.6775 56.2248 31.5568 57.6368 31.9812 58.9683C32.4057 60.2962 33.3205 61.3826 34.5609 62.0228C34.5609 62.0228 44.4735 67.144 48.3742 69.1559C48.956 69.4558 49.5451 69.7741 50.1123 70.085C50.3318 70.2057 50.5514 70.3228 50.7709 70.4435C54.2581 72.3274 58.3527 73.0663 62.2972 72.5176C66.3772 71.9543 70.0766 70.1106 72.9966 67.1915L74.5005 65.6881C81.8334 58.3574 81.8334 46.4323 74.5005 39.1053L60.7238 25.3329C58.7113 23.3356 55.4254 23.2478 53.3909 25.139Z" fill="white"/>
                            <path d="M53.3909 25.139C52.4578 26.0096 51.887 27.1546 51.7552 28.402C49.772 27.1765 47.1301 27.3485 45.3993 28.9617C44.4662 29.8323 43.8954 30.9772 43.7637 32.2246C41.7804 30.9992 39.1385 31.1711 37.4077 32.7843C36.5186 33.6146 35.9587 34.6901 35.794 35.868L27.2536 27.3302C25.2484 25.3256 21.9625 25.2341 19.9316 27.129C18.8815 28.1057 18.2924 29.4299 18.2667 30.8602C18.2411 32.2904 18.7827 33.6366 19.7963 34.6462L37.3272 52.1717C36.6759 52.1242 36.0136 52.2047 35.3732 52.4058C34.045 52.8302 32.9582 53.7447 32.3179 54.9847C31.6775 56.2248 31.5568 57.6368 31.9812 58.9683C32.4057 60.2962 33.3205 61.3826 34.5609 62.0228C34.5609 62.0228 44.4735 67.144 48.3742 69.1559C48.956 69.4558 49.5451 69.7741 50.1123 70.085C50.3318 70.2057 50.5514 70.3228 50.7709 70.4435C54.2581 72.3274 58.3527 73.0663 62.2972 72.5176C66.3772 71.9543 70.0766 70.1106 72.9966 67.1915L74.5005 65.6881C81.8334 58.3574 81.8334 46.4323 74.5005 39.1053L60.7238 25.3329C58.7113 23.3356 55.4254 23.2478 53.3909 25.139ZM73.0112 40.5905C79.5281 47.1054 79.5281 57.7063 73.0112 64.2212L71.5073 65.7247C66.3223 70.9081 58.199 72.0969 51.7516 68.6145L51.1003 68.2597C50.5221 67.9451 49.922 67.6195 49.3219 67.3086C45.4213 65.2967 35.5123 60.1755 35.5123 60.1755C34.7695 59.7914 34.2206 59.1402 33.9645 58.3428C33.712 57.5453 33.7815 56.6967 34.1657 55.9541C34.3194 55.6615 34.5097 55.4017 34.7329 55.1786C35.6733 54.2385 37.1479 53.9678 38.392 54.608L41.3376 56.1297C41.7877 56.3638 42.3439 56.2358 42.6476 55.8334C42.6549 55.8224 42.6659 55.8078 42.6732 55.7968C42.966 55.3798 42.9184 54.8165 42.5561 54.458L21.2672 33.1757C20.6598 32.5684 20.3342 31.7637 20.3488 30.9041C20.3634 30.0481 20.7184 29.2506 21.3477 28.6654C22.5662 27.5314 24.5495 27.5972 25.768 28.8153L37.265 40.3088L44.3784 47.42C44.7882 47.8297 45.4469 47.8297 45.8567 47.42C46.2665 47.0103 46.2665 46.3518 45.8567 45.9421L38.7433 38.831C38.1359 38.2237 37.8102 37.419 37.8249 36.5593C37.8395 35.7034 38.1944 34.9059 38.8238 34.3206C40.0423 33.1867 42.0256 33.2525 43.2441 34.4706L45.2566 36.4825L51.7516 42.9755C52.1614 43.3852 52.82 43.3852 53.2299 42.9755C53.6397 42.5658 53.6397 41.9073 53.2299 41.4977L46.7349 35.0047C46.1275 34.3975 45.8018 33.5927 45.8164 32.7331C45.8311 31.8771 46.1897 31.0796 46.8154 30.4944C48.0339 29.3604 50.0171 29.4262 51.2356 30.6443L53.2482 32.6562L58.7222 38.1286C59.1321 38.5383 59.7907 38.5383 60.2005 38.1286C60.6104 37.7189 60.6104 37.0605 60.2005 36.6508L54.7265 31.1784C54.119 30.5712 53.7934 29.7664 53.808 28.9068C53.8227 28.0472 54.1776 27.257 54.807 26.6681C56.0255 25.5341 58.0087 25.5999 59.2272 26.8181L73.0112 40.5905Z" fill="#898FA4"/>
                            <path d="M22.6904 49.7391C11.7934 49.7391 2.93098 40.8794 2.93098 29.9858C2.93098 19.0923 11.7934 10.2326 22.6904 10.2326C33.3421 10.2326 42.0509 18.7045 42.4314 29.2652C42.812 28.5629 43.306 27.919 43.8988 27.363C44.2683 27.0192 44.6745 26.7192 45.099 26.4632C43.4011 15.6245 33.9971 7.30615 22.6867 7.30615C10.1761 7.30615 0 17.4791 0 29.9858C0 42.4926 10.1761 52.6655 22.6867 52.6655C26.1885 52.6655 29.5073 51.868 32.4749 50.4451L30.2575 48.232C27.9266 49.1977 25.3725 49.7391 22.6904 49.7391Z" fill="#898FA4"/>
                            <path d="M22.6903 43.733C15.1049 43.733 8.93562 37.5656 8.93562 29.9825C8.93562 22.3995 15.1049 16.2321 22.6903 16.2321C30.2758 16.2321 36.4451 22.3995 36.4451 29.9825C36.4451 30.2386 36.4378 30.4947 36.4231 30.7471C37.2867 30.0813 38.2893 29.6277 39.3577 29.4009C39.0504 20.4607 31.7101 13.3057 22.6903 13.3057C13.4766 13.3057 6.0083 20.7717 6.0083 29.9825C6.0083 39.1934 13.4766 46.6594 22.6903 46.6594C24.498 46.6594 26.2397 46.3668 27.8717 45.8364L25.4823 43.4477C24.5785 43.6342 23.6454 43.733 22.6903 43.733Z" fill="#898FA4"/>
                            <path d="M14.9405 29.9858C14.9405 25.7133 18.4167 22.2382 22.6906 22.2382C25.7752 22.2382 28.4354 24.0525 29.6832 26.668L33.357 30.3407C33.3606 30.22 33.3643 30.1029 33.3643 29.9822C33.3643 24.0964 28.5745 19.3081 22.6869 19.3081C16.7993 19.3081 12.0095 24.0964 12.0095 29.9822C12.0095 35.8679 16.7993 40.6563 22.6832 40.6563L18.5484 36.5227C16.3859 35.1509 14.9405 32.7367 14.9405 29.9858Z" fill="#898FA4"/>
                          </svg>
                          <Trans>Пожалуйста, выберите нужный раздел</Trans>
                        </div>
                      :
                      (profile.profile.is_oneid || profile.profile.gcp_verified)  ? <AppealForm/> : <AuthComp/>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
};
export default observer(AppealPage)